// This file is automatically generated. Do not edit manually.

import { ControlChartLimitRow } from "src/api/generated/spc/controlChart/analysis/controlChartLimitRow";
import { IsoDateTimeString } from "src/types/dateTime";
import { ControlChartLimitCalculator_Limits } from "src/api/generated/spc/controlChart/analysis/controlChartLimitCalculator";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ControlChartLimitsApi {
	export async function getLimits(args: { controlChartId: number }): Promise<Array<ControlChartLimitRow>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/getLimits",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
			},
		});
		return response as Array<ControlChartLimitRow>;
	}

	export async function updateLimitNote(args: { limitsId: number; note: string | null | undefined }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/updateLimitNote",
			method: "POST",
			data: {
				limitsId: args.limitsId,
				note: args.note,
			},
		});
		return response as void;
	}

	export async function deleteLimits(args: { limitsId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/deleteLimits",
			method: "POST",
			data: {
				limitsId: args.limitsId,
			},
		});
		return response as void;
	}

	export async function getLimitCalculationUsageStart(args: {
		controlChartId: number;
		recordId: number | null | undefined;
	}): Promise<IsoDateTimeString> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/getLimitCalculationUsageStart",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
				recordId: args.recordId,
			},
		});
		return response as IsoDateTimeString;
	}

	export async function calculateLimits(args: {
		controlChartId: number;
		recordCount: number | null | undefined;
		recordId: number | null | undefined;
	}): Promise<ControlChartLimitsApi_LimitCalculationResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/calculateLimits",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
				recordCount: args.recordCount,
				recordId: args.recordId,
			},
		});
		return response as ControlChartLimitsApi_LimitCalculationResult;
	}

	export async function saveLimits(args: { input: ControlChartLimitsApi_SaveLimitsInput }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartLimits/saveLimits",
			method: "POST",
			data: {
				input: args.input,
			},
		});
		return response as number;
	}
}

export interface ControlChartLimitsApi_LimitCalculationResult {
	limits: ControlChartLimitCalculator_Limits;
}

export interface ControlChartLimitsApi_SaveLimitsInput {
	controlChartId: number;
	limits: ControlChartLimitCalculator_Limits;
	note: string | null | undefined;
	usageStart: IsoDateTimeString;
}
